import { LSystemInstructions, mapSymbolToInstruction, SymbolToInstruction } from './LSystemInstructions';
import Instruction from './Instruction';
import LSystem from '../core/LSystem';
import Visitor from '../core/Visitor';

export type DepthToInstruction = { [key: number]: Instruction[] };

/**
 * Stores all lsystem instruction streams for all levels.
 */
class CachedLSystemInstruction implements LSystemInstructions {
    maxDepth: number;
    depth: number;
    position: number;
    depthToInstruction: DepthToInstruction;

    constructor(maxDepth: number, depthToInstruction: DepthToInstruction) {
        this.maxDepth = maxDepth;

        this.depth = maxDepth;
        this.position = 0;
        this.depthToInstruction = depthToInstruction;
    }

    setDepth(depth: number): void {
        if (depth < this.maxDepth) {
            this.position = 0;
            this.depth = depth;
        }
    }

    next(): Instruction | null {
        const instructions = this.depthToInstruction[this.depth];

        if (instructions && this.position < instructions.length) {
            const retval = instructions[this.position];
            this.position++;
            return retval;
        }
        return null;
    }
}

const createFromLSystem = (
    lsystem: LSystem,
    maxDepth: number,
    symbolToInstruction: SymbolToInstruction,
): CachedLSystemInstruction => {
    const visitor = new Visitor(lsystem, maxDepth);
    const depthToInstruction: DepthToInstruction = {};

    let next = visitor.nextVal();
    while (next !== false) {
        const instruction = mapSymbolToInstruction(next.symbol, symbolToInstruction);
        if (instruction !== null) {
            for (let lvl = next.levelStart; lvl <= next.levelEnd; lvl++) {
                const instrList = depthToInstruction[lvl] || [];
                instrList.push(instruction);
                depthToInstruction[lvl] = instrList;
            }
        }
        next = visitor.nextVal();
    }

    return new CachedLSystemInstruction(maxDepth, depthToInstruction);
};

export { CachedLSystemInstruction, createFromLSystem };
